import React from 'react';
import {Divider, HStack, Heading, Text, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';

import {StackParamList} from '../../../../navigators';
import InternalTemplate from '../../../../components/templates/internal';
import {message} from '../../../../utils/messages';
import {useSalesmanContext} from '../../../../context/salesman';
import {IOrderDetailItem} from '../../../../interfaces/dtos';

const DetailItem = (props: {item: IOrderDetailItem}) => {
  const {item} = props;

  return (
    <>
      <HStack justifyContent={'space-between'} mt={5}>
        <VStack>
          <Heading fontSize={18} textAlign={'left'}>
            {item.title}
          </Heading>
          <Text fontSize={12} textAlign={'left'} color="#666666">
            {item.variant}
          </Text>
          <Text fontSize={12} textAlign={'left'} color="#666666">
            {item.category}
          </Text>
        </VStack>
        <VStack>
          <Heading fontSize={16} textAlign={'right'}>
            {`$ ${item.amount.foreign}`}
          </Heading>
          <Text textAlign={'right'} fontSize={16}>
            {`Bs. ${item.amount.local}`}
          </Text>
        </VStack>
      </HStack>
      <Divider mt={2} />
    </>
  );
};

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanOrderDetail'
>;

const OrderDetailScreen = ({navigation}: ScreenProps) => {
  const {orderDetail} = useSalesmanContext();

  const handleGoBack = () => {
    navigation.goBack();
  };

  const getTitle = () => {
    if (orderDetail) {
      return orderDetail.id;
    }
    return '';
  };

  return (
    <InternalTemplate
      title={getTitle()}
      contentPaddingX="5"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <Heading fontSize={18} color="#06355E">
        {message('sales-order-detail-label')}
      </Heading>
      <Text color="#99A2B4">
        {orderDetail && orderDetail.items.length}
        {` ${message('sales-order-items-count-label')}`}
      </Text>
      <Divider mt={2} />
      <VStack justifyContent="flex-start">
        {orderDetail &&
          orderDetail.items.map((item, position) => {
            return <DetailItem key={`key-${position}`} item={item} />;
          })}
      </VStack>
    </InternalTemplate>
  );
};

export default OrderDetailScreen;
